import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../common/Util.css";
import CommonDropdown from "../../common/common_dropDown";
import { Row, Col, Form, Button, Table } from "react-bootstrap";
import Sidebar from "../../common/Sidebar";
import { FiPlus, FiTrash2, FiInfo, FiMapPin, FiClock, FiEye } from "react-icons/fi";
import { ReactComponent as UploadIc } from "../../../assets/svg/upload.svg";
import { Modal } from "react-bootstrap";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import { saveCustomerAPI, updateCustomerAPI, getCustomerEditApi, addProfileAttachmentApi, addAttachmentApi } from "./customer-api";
import LoaderModal from "../../common/loader";
import { Navbar } from "../../common/Navbar";

// Fix for default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const LocationPicker = ({ setPosition }) => {
  useMapEvents({
    click(e) {
      setPosition(e.latlng);
    },
  });
  return null;
};

const MapUpdater = ({ center }) => {
  const map = useMapEvents({});

  useEffect(() => {
    if (center) {
      map.setView(center, 13);
    }
  }, [center, map]);

  return null;
};

const CustomerCreate = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};

  const [isLoader, setIsLoader] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (id != null) {
        try {
          const response = await getCustomerEditApi(id);
          if (response.data && response.data.success) {
            const data = response.data.customers;
            setCusId(data.code);
            setCusName(data.first_name);
            setMobile(data.phonenumber);
            setEmail(data.email);
            setAccName(data.bank_account_name);
            setAccNumber(data.bank_account_number);
            setGstNo(data.gst_number);
            setIfscCode(data.ifsc_code);
            setType(data.type);
            setMail(data.mail_alert);
            setSms(data.sms_alert);
            setWhatsapp(data.whatsapp_alert);
            setSameShipment(data.same_shipment === "true" || data.same_shipment === true);

            setFromAddress(data.billing_address);
            setFromCountryOption(
              data.billing_country_id !== null
                ? {
                    label: data.billing_country,
                    value: data.billing_country_id,
                  }
                : null
            );
            setFromStateOption(
              data.billing_state_id !== null
                ? {
                    label: data.billing_state,
                    value: data.billing_state_id,
                  }
                : null
            );
            setFromCityOption(
              data.billing_city_id !== null
                ? {
                    label: data.billing_city,
                    value: data.billing_city_id,
                  }
                : null
            );
            setFromZipCode(data.billing_zipcode);
            setAddr1({
              lat: data.billing_latitude,
              lng: data.billing_longitude,
            });

            setToAddress(data.shipping_address);
            setToCountryOption(
              data.shipping_country_id !== null
                ? {
                    label: data.shipping_country,
                    value: data.shipping_country_id,
                  }
                : null
            );
            setToStateOption(
              data.shipping_state_id !== null
                ? {
                    label: data.shipping_state,
                    value: data.shipping_state_id,
                  }
                : null
            );
            setToCityOption(
              data.shipping_city_id !== null
                ? {
                    label: data.shipping_city,
                    value: data.shipping_city_id,
                  }
                : null
            );
            setToZipCode(data.shipping_zipcode);
            setAddr2({
              lat: data.shipping_latitude,
              lng: data.shipping_longitude,
            });

            if (data.gate && data.gate.length > 0) {
              const formattedGates = data.gate.map((g) => ({
                id: g.id,
                name: g.gatename,
                // Handle both flat and nested structures
                gateIn: g.gate_in ? convertTo24Hour(g.gate_in) : g.gatedetails && g.gatedetails.length > 0 ? convertTo24Hour(g.gatedetails[0].gate_in) : "",
                gateOut: g.gate_out ? convertTo24Hour(g.gate_out) : g.gatedetails && g.gatedetails.length > 0 ? convertTo24Hour(g.gatedetails[0].gate_out) : "",
                sub_id: g.sub_id || (g.gatedetails && g.gatedetails.length > 0 ? g.gatedetails[0].sub_id : null),
              }));
              setGateDetails(formattedGates);
            }

            if (data.contact && data.contact.length > 0) {
              const formattedContacts = data.contact.map((c) => ({
                id: c.id,
                name: c.name,
                mobile: c.contact_number,
                email: c.email,
                type: c.contactname,
                inTime: convertTo24Hour(c.available_in_time),
                outTime: convertTo24Hour(c.available_out_time),
                isPrimary: c.priority === true,
              }));
              setContactPersons(formattedContacts);
            }

            if (data.sales) {
              setSales(data.sales);
            }
            if (data.Attachments && data.Attachments.length > 0) {
              const existingAttachments = data.Attachments.map((att) => ({
                id: att.id,
                name: att.file_name,
                size: att.file_size,
                base64: att.url,
                isExisting: true,
              }));
              setIdProof(existingAttachments);
            } else {
              setIdProof([]);
            }
            setProfilePhoto(data.profile || "");
            // Reset removed states on load
            setRemovedCustomerProof([]);
            setProfilePhotoRemoved(false);
          }
        } catch (error) {
          console.error("Error fetching customer data:", error);
        }
      }
    };
    fetchData();
  }, [id]);
  // set customer details
  const [cusId, setCusId] = useState("");
  const [cusName, setCusName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [accName, setAccName] = useState("");
  const [accNumber, setAccNumber] = useState("");
  const [gstNo, setGstNo] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [type, setType] = useState(null);
  const [mail, setMail] = useState(null);
  const [sms, setSms] = useState(null);
  const [whatsapp, setWhatsapp] = useState(false);
  const [sameShipment, setSameShipment] = useState(false);
  // set Address details
  const [fromAddress, setFromAddress] = useState("");
  const [fromAddressOption, setFromAddressOption] = useState(null);
  const [fromCountryOption, setFromCountryOption] = useState(null);
  const [fromStateOption, setFromStateOption] = useState(null);
  const [fromCityOption, setFromCityOption] = useState(null);
  const [fromZipCode, setFromZipCode] = useState("");

  const [toAddress, setToAddress] = useState("");
  const [toAddressOption, setToAddressOption] = useState(null);
  const [toCountryOption, setToCountryOption] = useState(null);
  const [toStateOption, setToStateOption] = useState(null);
  const [toCityOption, setToCityOption] = useState(null);
  const [toZipCode, setToZipCode] = useState("");
  const [idProof, setIdProof] = useState([]);
  const [idProofRemoved, setIdProofRemoved] = useState(false); // Used for tracking if all proofs are removed (UI logic mostly)
  const [removedCustomerProof, setRemovedCustomerProof] = useState([]); // IDs of removed existing attachments
  const [profilePhoto, setProfilePhoto] = useState("");
  const [profilePhotoRemoved, setProfilePhotoRemoved] = useState(false);

  const [errorMsg, setErrorMsg] = useState({
    customer_id: "",
    customer_name: "",
    mobilenumber: "",
    email: "",
    billing_address: "",
    billing_country_id: "",
    billing_state_id: "",
    billing_city_id: "",
    billing_zipcode: "",
    billing_latitude: "",
    billing_longitude: "",
    shipping_address: "",
    shipping_country_id: "",
    shipping_state_id: "",
    shipping_city_id: "",
    shipping_zipcode: "",
    shipping_latitude: "",
    shipping_longitude: "",
    account_name: "",
    gst_number: "",
    mail_alert: "",
    sms_alert: "",
    whatsapp_alert: "",
    gate_details: "",
    contact_persons: "",
    gate_name: "",
    contact_name: "",
    contact_number: "",
    contact_type: "",
  });

  const formatTime = (time24) => {
    if (!time24) return "";
    const [hours, minutes] = time24.split(":");
    const h = parseInt(hours, 10);
    const ampm = h >= 12 ? "PM" : "AM";
    const h12 = h % 12 || 12;
    return `${h12.toString().padStart(2, "0")}:${minutes} ${ampm}`;
  };

  const convertTo24Hour = (timeStr) => {
    if (!timeStr) return "";
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":");
    if (hours === "12") {
      hours = "00";
    }
    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours.toString().padStart(2, "0")}:${minutes}`;
  };

  const handleIdProofChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const newFile = {
          name: file.name,
          size: (file.size / 1024).toFixed(2) + " KB",
          base64: reader.result,
          isExisting: false,
        };
        setIdProof((prev) => [...prev, newFile]);
        setIdProofRemoved(false);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleProfilePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfilePhoto(reader.result);
        setProfilePhotoRemoved(false);
      };
      reader.readAsDataURL(file);
    }
  };

  const submitForm = async () => {
    setIsLoader(true);
    try {
      const contact = contactPersons.map((item) => ({
        id: item.id.toString().length < 10 ? item.id : undefined, // Send ID if it's not a temp ID (timestamp)
        contactname: item.type,
        name: item.name,
        contact_number: item.mobile,
        email: item.email,
        type: item.isPrimary ? "Primary" : "Secondary",
        available_in_time: formatTime(item.inTime),
        available_out_time: formatTime(item.outTime),
        priority: item.isPrimary ? 1 : 0,
      }));

      const gate = gateDetails.map((item) => {
        const gateObj = {
          gatename: item.name,
          gatedetails: [
            {
              gate_in: formatTime(item.gateIn),
              gate_out: formatTime(item.gateOut),
            },
          ],
        };

        // Only include id if it's a real existing ID (not a timestamp)
        if (item.id && item.id.toString().length < 10) {
          gateObj.id = item.id;
        }

        // Only include sub_id if it exists and is valid
        if (item.sub_id && item.sub_id.toString().length < 10) {
          gateObj.gatedetails[0].sub_id = item.sub_id;
        }

        return gateObj;
      });

      const payload = {
        customer_id: cusId,
        customer_name: cusName,
        mobilenumber: mobile,
        email: email,
        bank_account_name: accName,
        bank_account_number: accNumber,
        gst_number: gstNo,
        ifsc_code: ifscCode,
        type: type,
        mail_alert: mail,
        sms_alert: sms,
        whatsapp_alert: whatsapp,
        billing_address: fromAddress,
        billing_country_id: fromCountryOption?.value,
        billing_state_id: fromStateOption?.value,
        billing_city_id: fromCityOption?.value,
        billing_zipcode: fromZipCode,
        billing_latitude: addr1.lat,
        billing_longitude: addr1.lng,
        shipping_address: toAddress,
        shipping_country_id: toCountryOption?.value,
        shipping_state_id: toStateOption?.value,
        shipping_city_id: toCityOption?.value,
        shipping_zipcode: toZipCode,
        shipping_latitude: addr2.lat,
        shipping_longitude: addr2.lng,
        same_shipment: sameShipment,
        contact: contact,
        gate: gate,
        sales: sales,
        removed_gate: removedGateIds,
        removed_contact: removedContactIds,
        removed_gate_detail: [],
        removed_sales: [],
        removed_customer_proof: removedCustomerProof,
        removed_profile: profilePhotoRemoved,
        status: true,
      };

      console.log("Payload:", payload);

      let response;
      if (id) {
        response = await updateCustomerAPI(id, payload);
      } else {
        response = await saveCustomerAPI(payload);
      }

      if (response.data.success) {
        setIsLoader(false);
        navigate(-1);
        const newCustomerId = response.data.id || id;

        // Filter for NEW files only (those without an ID or isExisting is false)
        const newAttachments = idProof.filter((file) => !file.isExisting).map((file) => file.base64);

        if (newAttachments.length > 0) {
          await addAttachmentApi(newCustomerId, {
            attachments: newAttachments,
          });
        }

        // Only upload profile photo if it's a new one (base64 data) and not just the URL string
        if (profilePhoto && !profilePhoto.startsWith("http") && !profilePhotoRemoved) {
          await addProfileAttachmentApi(newCustomerId, {
            attachment: profilePhoto,
          });
        }
      } else {
        console.error("Error:", response.data);
        if (response.data.error) {
          const newErrorMsg = {};
          Object.keys(response.data.error).forEach((key) => {
            const errorValues = Array.isArray(response.data.error[key]) ? response.data.error[key] : [response.data.error[key]];

            errorValues.forEach((errorMessage) => {
              if (key === "gate_in" || key === "gate_out") {
                const match = errorMessage.match(/(\d+)\|(\d+)$/); // Match key|index
                if (match) {
                  const gateIndex = parseInt(match[1]);
                  // const detailIndex = parseInt(match[2]); // Not used for now as we only have 1 detail per gate
                  const field = key === "gate_in" ? "gateIn" : "gateOut";
                  const errorKey = `gate_${field}_${gateIndex}`;
                  newErrorMsg[errorKey] = errorMessage.replace(/\s\d+\|\d+$/, "");
                } else {
                  if (!newErrorMsg[key]) newErrorMsg[key] = errorMessage;
                }
              } else if (["contact_available_in_time", "contact_available_out_time", "contact_email", "name", "contact_number", "contact_type"].includes(key)) {
                const match = errorMessage.match(/(\d+)$/);
                if (match) {
                  const index = parseInt(match[1]);
                  let field = "";
                  if (key === "contact_available_in_time") field = "inTime";
                  else if (key === "contact_available_out_time") field = "outTime";
                  else if (key === "contact_email") field = "email";
                  else if (key === "name") field = "name";
                  else if (key === "contact_number") field = "mobile";
                  else if (key === "contact_type") field = "type";

                  const errorKey = `contact_${field}_${index}`;
                  newErrorMsg[errorKey] = errorMessage.replace(/\s\d+$/, "");
                } else {
                  if (!newErrorMsg[key]) newErrorMsg[key] = errorMessage;
                }
              } else if (key === "gate_name") {
                const match = errorMessage.match(/(\d+)$/);
                if (match) {
                  const index = parseInt(match[1]);
                  const errorKey = `gate_name_${index}`;
                  newErrorMsg[errorKey] = errorMessage.replace(/\s\d+$/, "");
                } else {
                  newErrorMsg[key] = errorMessage;
                }
              } else {
                if (!newErrorMsg[key]) newErrorMsg[key] = errorMessage;
              }
            });
          });
          setErrorMsg(newErrorMsg);
        }
      }
    } catch (err) {
      console.error("Error submitting form:", err);
    } finally {
      setIsLoader(false);
    }
  };

  const [gateDetails, setGateDetails] = useState([
    // { id: Date.now(), name: "", gateIn: "", gateOut: "" },
  ]);
  const [contactPersons, setContactPersons] = useState([
    // {
    //   id: Date.now() + 1,
    //   name: "",
    //   mobile: "",
    //   email: "",
    //   type: "",
    //   inTime: "",
    //   outTime: "",
    //   isPrimary: false,
    // },
  ]);
  const [sales, setSales] = useState([]);
  const [removedGateIds, setRemovedGateIds] = useState([]);
  const [removedContactIds, setRemovedContactIds] = useState([]);

  // Map state
  const [showMap, setShowMap] = useState(false);
  const [mapPosition, setMapPosition] = useState(null);
  const [activeField, setActiveField] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [mapCenter, setMapCenter] = useState([20.5937, 78.9629]);
  const [isSearching, setIsSearching] = useState(false);

  const [addr1, setAddr1] = useState({ lat: "", lng: "" });
  const [addr2, setAddr2] = useState({ lat: "", lng: "" });

  const handleMapConfirm = () => {
    if (mapPosition) {
      const lat = mapPosition.lat.toFixed(6);
      const lng = mapPosition.lng.toFixed(6);

      if (activeField === "addr1") {
        setAddr1({ lat, lng });
      } else if (activeField === "addr2") {
        setAddr2({ lat, lng });
      }

      setShowMap(false);
      setMapPosition(null);
      setSearchQuery("");
      setSearchResults([]);
    }
  };

  const handleSearch = async () => {
    if (!searchQuery.trim()) return;

    setIsSearching(true);
    try {
      const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}&limit=5`);
      const data = await response.json();
      setSearchResults(data);
    } catch (error) {
      console.error("Error searching location:", error);
      setSearchResults([]);
    } finally {
      setIsSearching(false);
    }
  };

  const handleSelectSearchResult = (result) => {
    const lat = parseFloat(result.lat);
    const lng = parseFloat(result.lon);
    setMapCenter([lat, lng]);
    setMapPosition({ lat, lng });
    setSearchResults([]);
    setSearchQuery(result.display_name);
  };

  const addGateDetail = () => {
    setGateDetails([...gateDetails, { id: Date.now(), name: "", gateIn: "", gateOut: "", sub_id: null }]);
  };

  const removeGateDetail = (id) => {
    if (id.toString().length < 10) {
      setRemovedGateIds([...removedGateIds, id]);
    }
    setGateDetails(gateDetails.filter((item) => item.id !== id));
  };

  const addContactPerson = () => {
    setContactPersons([
      ...contactPersons,
      {
        id: Date.now(),
        name: "",
        mobile: "",
        email: "",
        type: "",
        inTime: "",
        outTime: "",
        isPrimary: false,
      },
    ]);
  };

  const removeContactPerson = (id) => {
    if (id.toString().length < 10) {
      setRemovedContactIds([...removedContactIds, id]);
    }
    setContactPersons(contactPersons.filter((item) => item.id !== id));
  };

  const handleGateChange = (id, field, value) => {
    setGateDetails(gateDetails.map((item) => (item.id === id ? { ...item, [field]: value } : item)));
  };

  const handleContactChange = (id, field, value) => {
    setContactPersons(contactPersons.map((item) => (item.id === id ? { ...item, [field]: value } : item)));
  };

  return (
    <div
      className="d-flex"
      style={{
        backgroundColor: "#f8f9fa",
        minHeight: "100vh",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <LoaderModal show={isLoader} />
      <Sidebar currentfile="Customer" />

      <div
        style={{
          width: "calc(100vw - 80px)",
          overflowY: "auto",
          height: "100vh",
        }}
      >
        <Navbar pageTitle="Customer" />
        {/* Header */}
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="fw-600 m-0" style={{ fontSize: "20px" }}>
              New Customer
            </h4>
            <div className="d-flex gap-2">
              <Button variant="light" className="bg-white border fw-500" style={{ color: "#495057" }} onClick={() => navigate(-1)}>
                Cancel
              </Button>
              <Button variant="primary" className="fw-500" style={{ backgroundColor: "#3469E7", borderColor: "#3469E7" }} onClick={submitForm} disabled={isLoader}>
                {isLoader ? "Saving..." : "Save"}
              </Button>
            </div>
          </div>

          <Row className="g-3">
            {/* Left Column - Customer Details */}
            <Col md={8}>
              <div className="bg-white p-4 rounded shadow-sm h-100 text-start">
                <h5 className="fw-600 mb-4" style={{ fontSize: "16px" }}>
                  Customer details
                </h5>
                <div className="d-flex align-items-center gap-3 mb-4">
                  <div className="rounded-circle bg-light d-flex align-items-center justify-content-center overflow-hidden" style={{ width: "64px", height: "64px", color: "#adb5bd" }}>
                    {profilePhoto ? (
                      <img
                        src={profilePhoto}
                        alt="Profile"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                      </svg>
                    )}
                  </div>
                  <div>
                    <input type="file" id="profile-photo" className="d-none" accept="image/*" onChange={handleProfilePhotoChange} />
                    <div className="d-flex gap-2">
                      <Button variant="outline-primary" size="sm" className="d-flex align-items-center gap-1 rounded-pill px-3" onClick={() => document.getElementById("profile-photo").click()}>
                        <FiPlus /> {profilePhoto ? "Change photo" : "Add photo"}
                      </Button>
                      {profilePhoto && (
                        <Button
                          variant="outline-danger"
                          size="sm"
                          className="d-flex align-items-center gap-1 rounded-pill px-3"
                          onClick={() => {
                            setProfilePhoto("");
                            setProfilePhotoRemoved(true);
                          }}
                        >
                          <FiTrash2 /> Remove
                        </Button>
                      )}
                    </div>
                  </div>
                </div>

                <Row className="g-3 text-start">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-400 fs-13 mb-1">
                        Customer ID <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control type="text" placeholder="Enter here..." className="fs-13" value={cusId} onChange={(e) => setCusId(e.target.value)} />
                      {errorMsg.customer_id && <span className="text-danger fs-12">{errorMsg.customer_id}</span>}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-400 fs-13 mb-1">
                        Customer Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control type="text" placeholder="Enter here..." className="fs-13" value={cusName} onChange={(e) => setCusName(e.target.value)} />
                      {errorMsg.customer_name && <span className="text-danger fs-12">{errorMsg.customer_name}</span>}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-400 fs-13 mb-1">
                        Mobile Number <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control type="text" placeholder="Enter here..." className="fs-13" value={mobile} onChange={(e) => setMobile(e.target.value)} />
                      {errorMsg.mobilenumber && <span className="text-danger fs-12">{errorMsg.mobilenumber}</span>}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-400 fs-13 mb-1">
                        Type <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select className="fs-13 text-muted" value={type} onChange={(e) => setType(e.target.value)}>
                        <option value="">Select</option>
                        <option value="Retail">Retail</option>
                        <option value="Wholesale">Wholesale</option>
                      </Form.Select>
                      {errorMsg.type && <span className="text-danger fs-12">{errorMsg.type}</span>}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-400 fs-13 mb-1">
                        Email <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control type="text" placeholder="Enter here..." className="fs-13" value={email} onChange={(e) => setEmail(e.target.value)} />
                      {errorMsg.email && <span className="text-danger fs-12">{errorMsg.email}</span>}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-400 fs-13 mb-1">Bank Account Name</Form.Label>
                      <Form.Control type="text" placeholder="Enter here..." className="fs-13" value={accName} onChange={(e) => setAccName(e.target.value)} />
                      {errorMsg.bank_account_name && <span className="text-danger fs-12">{errorMsg.bank_account_name}</span>}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-400 fs-13 mb-1">Bank Account Number</Form.Label>
                      <Form.Control type="text" placeholder="Enter here..." className="fs-13" value={accNumber} onChange={(e) => setAccNumber(e.target.value)} />
                      {errorMsg.bank_account_number && <span className="text-danger fs-12">{errorMsg.bank_account_number}</span>}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-400 fs-13 mb-1">IFSC Code</Form.Label>
                      <Form.Control type="text" placeholder="Enter here..." className="fs-13" value={ifscCode} onChange={(e) => setIfscCode(e.target.value)} />
                      {errorMsg.ifsc_code && <span className="text-danger fs-12">{errorMsg.ifsc_code}</span>}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-400 fs-13 mb-1">GST Number</Form.Label>
                      <Form.Control type="text" placeholder="Enter here..." className="fs-13" value={gstNo} onChange={(e) => setGstNo(e.target.value)} />
                      {errorMsg.gst_number && <span className="text-danger fs-12">{errorMsg.gst_number}</span>}
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </Col>

            {/* Right Column - Image & Config */}
            <Col md={4}>
              <div className="d-flex flex-column gap-3 h-100 text-start">
                {/* Customer Image */}
                <div className="bg-white p-4 rounded shadow-sm">
                  <h5 className="fw-600 mb-3" style={{ fontSize: "16px" }}>
                    Customer proof
                  </h5>
                  <div
                    className="border rounded d-flex flex-column align-items-center justify-content-center p-4 text-center overflow-hidden"
                    style={{
                      backgroundColor: "#f8f9fa",
                      borderColor: "#dee2e6",
                      minHeight: "140px",
                      borderStyle: "dashed",
                      position: "relative",
                    }}
                  >
                    {idProof.length > 0 ? (
                      <div className="w-100 d-flex flex-column gap-2">
                        <div className="d-flex flex-column gap-2 pe-1" style={{ maxHeight: "120px", overflowY: "auto" }}>
                          {idProof.map((file, index) => (
                            <div key={index} className="d-flex align-items-center justify-content-between p-2 border rounded bg-white">
                              <div className="d-flex align-items-center gap-2 overflow-hidden">
                                <div className="text-primary">
                                  <UploadIc width="20" height="20" />
                                </div>
                                <div className="d-flex flex-column text-start overflow-hidden">
                                  <span className="fs-12 fw-500 text-truncate" style={{ maxWidth: "150px" }}>
                                    {file.name}
                                  </span>
                                  <span className="text-muted" style={{ fontSize: "10px" }}>
                                    {file.size}
                                  </span>
                                </div>
                              </div>
                              <div className="d-flex align-items-center gap-1">
                                {/* <Button
                                variant="light"
                                size="sm"
                                className="p-1 rounded-circle"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (file.base64) {
                                    const newWindow = window.open();
                                    newWindow.document.write(`<iframe src="${file.base64}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`);
                                  }
                                }}
                              >
                                <FiEye size={14} color="#3469E7" />
                              </Button> */}
                                <Button
                                  variant="light"
                                  size="sm"
                                  className="p-1 rounded-circle"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    // If it's an existing file, add its ID to the removed list
                                    if (file.isExisting && file.id) {
                                      setRemovedCustomerProof((prev) => [...prev, file.id]);
                                    }

                                    const newFiles = idProof.filter((_, i) => i !== index);
                                    setIdProof(newFiles);
                                    if (newFiles.length === 0) {
                                      setIdProofRemoved(true);
                                    }
                                  }}
                                >
                                  <FiTrash2 size={14} color="red" />
                                </Button>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="mt-2 text-primary fs-12 fw-500 cursor-pointer" onClick={() => document.getElementById("customer-proof").click()}>
                          + Add another file
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="mb-2 text-primary">
                          <UploadIc width="32" height="32" />
                        </div>
                        <div className="fs-12 fw-500 mb-1">
                          Drag and drop or{" "}
                          <span className="text-primary cursor-pointer" onClick={() => document.getElementById("customer-proof").click()}>
                            Select a file
                          </span>
                        </div>
                        <div className="text-muted" style={{ fontSize: "10px" }}>
                          You can add multiple files here
                        </div>
                      </>
                    )}
                    <input type="file" id="customer-proof" className="d-none" accept="image/*" onChange={handleIdProofChange} />
                  </div>
                </div>

                {/* Configurations */}
                {/* <div className="bg-white p-4 rounded shadow-sm flex-grow-1">
                  <h5 className="fw-600 mb-3" style={{ fontSize: "16px" }}>
                    Configurations :-
                  </h5>
                  <div className="d-flex flex-column gap-3">
                    <Form.Check
                      type="checkbox"
                      id="mail-alert"
                      label="Mail alert"
                      className="fs-14 fw-500"
                      checked={mail || false}
                      onChange={(e) => setMail(e.target.checked)}
                    />
                    {errorMsg.mail_alert && (
                      <span className="text-danger fs-12">
                        {errorMsg.mail_alert}
                      </span>
                    )}
                    <Form.Check
                      type="checkbox"
                      id="sms-alert"
                      label="SMS alert"
                      className="fs-14 fw-500"
                      checked={sms || false}
                      onChange={(e) => setSms(e.target.checked)}
                    />
                    {errorMsg.sms_alert && (
                      <span className="text-danger fs-12">
                        {errorMsg.sms_alert}
                      </span>
                    )}
                    <Form.Check
                      type="checkbox"
                      id="whatsapp-alert"
                      label="WhatsApp alert"
                      className="fs-14 fw-500"
                      checked={whatsapp || false}
                      onChange={(e) => setWhatsapp(e.target.checked)}
                    />
                    {errorMsg.whatsapp_alert && (
                      <span className="text-danger fs-12">
                        {errorMsg.whatsapp_alert}
                      </span>
                    )}
                  </div>
                </div> */}
              </div>
            </Col>

            {/* Addresses */}
            <Col md={6}>
              <div className="bg-white p-4 rounded shadow-sm h-100 text-start">
                <h5 className="fw-600 mb-3" style={{ fontSize: "16px" }}>
                  Billing address
                </h5>
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-400 fs-13 mb-1">
                        Address <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control type="text" placeholder="Enter here..." className="fs-13" value={fromAddress} onChange={(e) => setFromAddress(e.target.value)} />
                      {errorMsg.billing_address && <span className="text-danger fs-12">{errorMsg.billing_address}</span>}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <div className="mt-2 col-12   d-flex flex-column align-items-start">
                      <div className="form-label fs-12 fw-400 my-0 mb-1" style={{ color: "#28303F" }}>
                        City <span className="text-danger">*</span>
                      </div>
                      <div className="w-100">
                        <CommonDropdown
                          apiUrl={`${adminUrl}get_city?state_id=${fromStateOption != null ? fromStateOption.value : ""}`}
                          placeholder="Select"
                          value={fromCityOption}
                          onSelect={(item) => {
                            setFromCityOption(item);
                            setFromStateOption({
                              value: item.state_id,
                              label: item.state_name,
                            });
                            setFromCountryOption({
                              value: item.country_id,
                              label: item.country_name,
                            });
                          }}
                        />
                      </div>
                      {errorMsg.billing_city_id && (
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "6px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.billing_city_id}
                        </span>
                      )}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mt-2 col-12   d-flex flex-column align-items-start  ps-0">
                      <div className="form-label fs-12 fw-400 my-0 mb-1" style={{ color: "#28303F" }}>
                        State <span className="text-danger">*</span>
                      </div>
                      <div className="w-100">
                        <CommonDropdown
                          apiUrl={`${adminUrl}get_state?country_id=${fromCountryOption != null ? fromCountryOption.value : ""}`}
                          placeholder="Select"
                          value={fromStateOption}
                          onSelect={(item) => {
                            setFromStateOption(item);
                            setFromCountryOption({
                              value: item.country_id,
                              label: item.country_name,
                            });
                          }}
                        />
                      </div>
                      {errorMsg.billing_state_id && (
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "6px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.billing_state_id}
                        </span>
                      )}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mt-2 col-12   d-flex flex-column align-items-start">
                      <div className="form-label fs-12 fw-400 my-0 mb-1" style={{ color: "#28303F" }}>
                        Country <span className="text-danger">*</span>
                      </div>
                      <div className="w-100">
                        <CommonDropdown
                          apiUrl={`${adminUrl}get_country`}
                          placeholder="Select"
                          value={fromCountryOption}
                          onSelect={(item) => {
                            setFromCountryOption(item);
                          }}
                        />
                      </div>
                      {errorMsg.billing_country_id && (
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "6px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.billing_country_id}
                        </span>
                      )}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mt-2 col-12   d-flex flex-column align-items-start ps-0">
                      <div className="form-label fs-12 fw-400 my-0 mb-1" style={{ color: "#28303F" }}>
                        Zip code <span className="text-danger">*</span>
                      </div>
                      <div className="w-100">
                        <input
                          type="text"
                          className="form-control rounded-3 fs-13"
                          id="zipcode"
                          placeholder="Enter here"
                          value={fromZipCode}
                          onChange={(e) => {
                            setFromZipCode(e.target.value);
                          }}
                        />
                      </div>
                      {errorMsg.billing_zipcode && (
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "6px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.billing_zipcode}
                        </span>
                      )}
                    </div>
                  </Col>
                  <Col md={4}>
                    <Form.Control type="text" placeholder="Latitude" className="fs-13" value={addr1.lat} onChange={(e) => setAddr1({ ...addr1, lat: e.target.value })} readOnly />
                    {errorMsg.billing_latitude && <span className="text-danger fs-12">{errorMsg.billing_latitude}</span>}
                  </Col>
                  <Col md={4}>
                    <Form.Control type="text" placeholder="Longitude" className="fs-13" value={addr1.lng} onChange={(e) => setAddr1({ ...addr1, lng: e.target.value })} readOnly />
                    {errorMsg.billing_longitude && <span className="text-danger fs-12">{errorMsg.billing_longitude}</span>}
                  </Col>
                  <Col md={4}>
                    <Button
                      variant="primary"
                      className="w-100 fs-13 fw-500 d-flex align-items-center justify-content-center gap-1"
                      style={{
                        backgroundColor: "#3469E7",
                        borderColor: "#3469E7",
                      }}
                      onClick={() => {
                        setActiveField("addr1");
                        setMapPosition(null);
                        setShowMap(true);
                      }}
                    >
                      Pin in map
                    </Button>
                  </Col>
                </Row>
              </div>
            </Col>

            <Col md={6}>
              <div className="bg-white p-4 rounded shadow-sm h-100 text-start">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="fw-600 m-0" style={{ fontSize: "16px" }}>
                    Shipping address
                  </h5>
                  <Form.Check
                    type="checkbox"
                    label="Same as billing"
                    className="fs-13 fw-500"
                    checked={sameShipment}
                    onChange={(e) => {
                      setSameShipment(e.target.checked);
                      if (e.target.checked) {
                        setToAddress(fromAddress);
                        setToCountryOption(fromCountryOption);
                        setToStateOption(fromStateOption);
                        setToCityOption(fromCityOption);
                        setToZipCode(fromZipCode);
                        setAddr2(addr1);
                      } else {
                        setToAddress("");
                        setToCountryOption(null);
                        setToStateOption(null);
                        setToCityOption(null);
                        setToZipCode("");
                        setAddr2({ lat: "", lng: "" });
                      }
                    }}
                  />
                </div>
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-400 fs-13 mb-1">
                        Address <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control type="text" placeholder="Enter here..." className="fs-13" value={toAddress} onChange={(e) => setToAddress(e.target.value)} disabled={sameShipment} />
                      {errorMsg.shipping_address && <span className="text-danger fs-12">{errorMsg.shipping_address}</span>}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <div className="mt-2 col-12   d-flex flex-column align-items-start">
                      <div className="form-label fs-12 fw-400 my-0 mb-1" style={{ color: "#28303F" }}>
                        City <span className="text-danger">*</span>
                      </div>
                      <div className="w-100">
                        <CommonDropdown
                          apiUrl={`${adminUrl}get_city?state_id=${toStateOption != null ? toStateOption.value : ""}`}
                          placeholder="Select"
                          value={toCityOption}
                          onSelect={(item) => {
                            setToCityOption(item);
                            setToStateOption({
                              value: item.state_id,
                              label: item.state_name,
                            });
                            setToCountryOption({
                              value: item.country_id,
                              label: item.country_name,
                            });
                          }}
                          disabled={sameShipment}
                        />
                      </div>
                      {errorMsg.shipping_city_id && <span className="text-danger fs-12 mt-1">{errorMsg.shipping_city_id}</span>}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mt-2 col-12   d-flex flex-column align-items-start ps-0">
                      <div className="form-label fs-12 fw-400 my-0 mb-1" style={{ color: "#28303F" }}>
                        State <span className="text-danger">*</span>
                      </div>
                      <div className="w-100">
                        <CommonDropdown
                          apiUrl={`${adminUrl}get_state?country_id=${toCountryOption != null ? toCountryOption.value : ""}`}
                          placeholder="Select"
                          value={toStateOption}
                          onSelect={(item) => {
                            setToStateOption(item);
                            setToCountryOption({
                              value: item.country_id,
                              label: item.country_name,
                            });
                          }}
                          disabled={sameShipment}
                        />
                      </div>
                      {errorMsg.shipping_state_id && <span className="text-danger fs-12 mt-1">{errorMsg.shipping_state_id}</span>}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mt-2 col-12   d-flex flex-column align-items-start">
                      <div className="form-label fs-12 fw-400 my-0 mb-1" style={{ color: "#28303F" }}>
                        Country <span className="text-danger">*</span>
                      </div>
                      <div className="w-100">
                        <CommonDropdown apiUrl={`${adminUrl}get_country`} placeholder="Select" value={toCountryOption} onSelect={(item) => setToCountryOption(item)} disabled={sameShipment} />
                      </div>
                      {errorMsg.shipping_country_id && <span className="text-danger fs-12 mt-1">{errorMsg.shipping_country_id}</span>}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mt-2 col-12   d-flex flex-column align-items-start ps-0">
                      <div className="form-label fs-12 fw-400 my-0 mb-1" style={{ color: "#28303F" }}>
                        Zip code <span className="text-danger">*</span>
                      </div>
                      <div className="w-100">
                        <input type="text" className="form-control rounded-3 fs-13" placeholder="Enter here" value={toZipCode} onChange={(e) => setToZipCode(e.target.value)} disabled={sameShipment} />
                      </div>
                      {errorMsg.shipping_zipcode && <span className="text-danger fs-12 mt-1">{errorMsg.shipping_zipcode}</span>}
                    </div>
                  </Col>
                  <Col md={4}>
                    <Form.Control type="text" placeholder="Latitude" className="fs-13" value={addr2.lat} onChange={(e) => setAddr2({ ...addr2, lat: e.target.value })} readOnly />
                    {errorMsg.shipping_latitude && <span className="text-danger fs-12">{errorMsg.shipping_latitude}</span>}
                  </Col>
                  <Col md={4}>
                    <Form.Control type="text" placeholder="Longitude" className="fs-13" value={addr2.lng} onChange={(e) => setAddr2({ ...addr2, lng: e.target.value })} readOnly />
                    {errorMsg.shipping_longitude && <span className="text-danger fs-12">{errorMsg.shipping_longitude}</span>}
                  </Col>
                  <Col md={4}>
                    <Button
                      variant="primary"
                      className="w-100 fs-13 fw-500 d-flex align-items-center justify-content-center gap-1"
                      style={{
                        backgroundColor: "#3469E7",
                        borderColor: "#3469E7",
                      }}
                      onClick={() => {
                        if (!sameShipment) {
                          setActiveField("addr2");
                          setMapPosition(null);
                          setShowMap(true);
                        }
                      }}
                      disabled={sameShipment}
                    >
                      Pin in map
                    </Button>
                  </Col>
                </Row>
              </div>
            </Col>

            {/* Gate Details */}
            <Col md={12}>
              <div className="bg-white p-4 rounded shadow-sm text-start">
                <h5 className="fw-600 mb-3" style={{ fontSize: "16px" }}>
                  Gate Details
                </h5>
                <div className="table-responsive">
                  <Table borderless className="align-middle mb-0">
                    <thead className="bg-light text-secondary fs-11 text-uppercase">
                      <tr>
                        <th style={{ width: "40px" }} className="border-0 fw-600 py-2 bg-light">
                          <Form.Check />
                        </th>
                        <th className="border-0 fw-600 text-muted py-2 bg-light">Gate Name</th>
                        <th className="border-0 fw-600 text-muted py-2 bg-light">Gate In</th>
                        <th className="border-0 fw-600 text-muted py-2 bg-light">Gate Out</th>
                        <th style={{ width: "40px" }} className="bg-light"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {gateDetails.map((item, index) => (
                        <tr key={item.id} style={{ borderBottom: "1px solid #F1F5F9" }}>
                          <td className="ps-4 py-2">
                            <Form.Check />
                          </td>
                          <td className=" py-2">
                            <Form.Control type="text" placeholder="Enter here..." className="fs-13 shadow-none" style={{ borderColor: "#E2E8F0" }} value={item.name} onChange={(e) => handleGateChange(item.id, "name", e.target.value)} />
                            {errorMsg[`gate_name_${index}`] && <span className="text-danger fs-12">{errorMsg[`gate_name_${index}`]}</span>}
                          </td>
                          <td className=" py-2">
                            <Form.Control
                              type="time"
                              className="fs-13 shadow-none"
                              style={{
                                borderColor: "#E2E8F0",
                                maxWidth: "150px",
                              }}
                              value={item.gateIn}
                              onChange={(e) => handleGateChange(item.id, "gateIn", e.target.value)}
                            />
                            {errorMsg[`gate_gateIn_${index}`] && <span className="text-danger fs-12">{errorMsg[`gate_gateIn_${index}`]}</span>}
                          </td>
                          <td className=" py-2">
                            <Form.Control
                              type="time"
                              className="fs-13 shadow-none"
                              style={{
                                borderColor: "#E2E8F0",
                                maxWidth: "150px",
                              }}
                              value={item.gateOut}
                              onChange={(e) => handleGateChange(item.id, "gateOut", e.target.value)}
                            />
                            {errorMsg[`gate_gateOut_${index}`] && <span className="text-danger fs-12">{errorMsg[`gate_gateOut_${index}`]}</span>}
                          </td>
                          <td className="pe-4 text-end py-2" style={{ borderLeft: "1px solid #E2E8F0" }}>
                            <Button variant="link" className="text-danger p-0" onClick={() => removeGateDetail(item.id)}>
                              <FiTrash2 size={16} />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
                <div className="mt-3">
                  <Button variant="light" className="text-primary fw-400 fs-13 d-flex align-items-center gap-2" style={{ backgroundColor: "#EBF2FF" }} onClick={addGateDetail}>
                    <FiPlus /> Add Item
                  </Button>
                </div>
              </div>
            </Col>

            {/* Customer Details (Contact Persons) */}
            <Col md={12}>
              <div className="bg-white p-4 rounded shadow-sm text-start">
                <h5 className="fw-600 mb-3" style={{ fontSize: "16px" }}>
                  Customer Details
                </h5>
                <div className="table-responsive">
                  <Table className="align-middle mb-0">
                    <thead className="text-secondary fs-11 text-uppercase" style={{ backgroundColor: "#F7F8FC" }}>
                      <tr style={{ borderBottom: "1px solid #E2E8F0" }}>
                        <th style={{ width: "40px" }} className="border-0 ps-4 py-2 bg-light">
                          <Form.Check />
                        </th>
                        <th className="border-0 fw-600 text-muted py-2 bg-light">Name</th>
                        <th className="border-0 fw-600 text-muted py-2 bg-light">Mobile No.</th>
                        <th className="border-0 fw-600 text-muted py-2 bg-light">Email</th>
                        <th className="border-0 fw-600 text-muted py-2 bg-light">Type</th>
                        <th className="border-0 fw-600 text-muted py-2 bg-light">Available Time</th>
                        <th className="border-0 fw-600 text-muted py-2 bg-light">Primary</th>
                        <th style={{ width: "60px" }} className="border-0 pe-4 py-2 bg-light"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {contactPersons.map((item, index) => (
                        <tr key={item.id} style={{ borderBottom: "1px solid #F1F5F9" }}>
                          <td className="ps-4 py-2">
                            <Form.Check />
                          </td>
                          <td className="py-2">
                            <Form.Control type="text" placeholder="Enter here..." className="fs-13 shadow-none" style={{ borderColor: "#E2E8F0" }} value={item.name} onChange={(e) => handleContactChange(item.id, "name", e.target.value)} />
                            {errorMsg[`contact_name_${index}`] && <span className="text-danger fs-12">{errorMsg[`contact_name_${index}`]}</span>}
                          </td>
                          <td className="py-2">
                            <Form.Control type="text" placeholder="Mobile No." className="fs-13 shadow-none" style={{ borderColor: "#E2E8F0" }} value={item.mobile} onChange={(e) => handleContactChange(item.id, "mobile", e.target.value)} />
                            {errorMsg[`contact_mobile_${index}`] && <span className="text-danger fs-12">{errorMsg[`contact_mobile_${index}`]}</span>}
                          </td>
                          <td className="py-2">
                            <Form.Control type="text" placeholder="Enter here..." className="fs-13 shadow-none" style={{ borderColor: "#E2E8F0" }} value={item.email} onChange={(e) => handleContactChange(item.id, "email", e.target.value)} />
                            {errorMsg[`contact_email_${index}`] && <span className="text-danger fs-12">{errorMsg[`contact_email_${index}`]}</span>}
                          </td>
                          <td className="py-2">
                            <Form.Select className="fs-13 text-muted shadow-none" style={{ borderColor: "#E2E8F0" }} value={item.type} onChange={(e) => handleContactChange(item.id, "type", e.target.value)}>
                              <option value="">Select</option>
                              <option value="Manager">Manager</option>
                              <option value="Accountant">Accountant</option>
                              <option value="Other">Other</option>
                            </Form.Select>
                            {errorMsg[`contact_type_${index}`] && <span className="text-danger fs-12">{errorMsg[`contact_type_${index}`]}</span>}
                          </td>
                          <td className="py-2">
                            <div className="d-flex align-items-center gap-2">
                              <Form.Control type="time" className="fs-13 shadow-none" style={{ borderColor: "#E2E8F0" }} value={item.inTime} onChange={(e) => handleContactChange(item.id, "inTime", e.target.value)} />
                              <span className="text-muted">-</span>
                              <Form.Control type="time" className="fs-13 shadow-none" style={{ borderColor: "#E2E8F0" }} value={item.outTime} onChange={(e) => handleContactChange(item.id, "outTime", e.target.value)} />
                            </div>
                            {errorMsg[`contact_inTime_${index}`] && <span className="text-danger fs-12 d-block">{errorMsg[`contact_inTime_${index}`]}</span>}
                            {errorMsg[`contact_outTime_${index}`] && <span className="text-danger fs-12 d-block">{errorMsg[`contact_outTime_${index}`]}</span>}
                          </td>
                          <td className="py-2">
                            <Form.Check type="checkbox" label={item.isPrimary ? "Primary" : "Secondary"} className="fs-13 fw-600" checked={item.isPrimary} onChange={(e) => handleContactChange(item.id, "isPrimary", e.target.checked)} />
                          </td>
                          <td className="pe-4 text-end py-2" style={{ borderLeft: "1px solid #E2E8F0" }}>
                            <Button variant="link" className="text-danger p-0" onClick={() => removeContactPerson(item.id)}>
                              <FiTrash2 size={16} />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
                <div className="mt-3">
                  <Button variant="light" className="text-primary fw-400 fs-13 d-flex align-items-center gap-2" style={{ backgroundColor: "#EBF2FF" }} onClick={addContactPerson}>
                    <FiPlus /> Add Customer
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Map Modal */}
      <Modal
        show={showMap}
        onHide={() => {
          setShowMap(false);
          setSearchQuery("");
          setSearchResults([]);
        }}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Location</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Search Bar */}
          <div className="mb-3">
            <div className="d-flex gap-2">
              <div style={{ position: "relative", flex: 1 }}>
                <Form.Control
                  type="text"
                  placeholder="Search for a location (e.g., Mumbai, India or specific address)"
                  className="fs-13"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearch();
                    }
                  }}
                />

                {searchResults.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      backgroundColor: "white",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      maxHeight: "200px",
                      overflowY: "auto",
                      zIndex: 1000,
                      marginTop: "4px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }}
                  >
                    {searchResults.map((result, index) => (
                      <div
                        key={index}
                        className="p-2 cursor-pointer"
                        style={{
                          borderBottom: index < searchResults.length - 1 ? "1px solid #f1f3f5" : "none",
                          cursor: "pointer",
                        }}
                        onClick={() => handleSelectSearchResult(result)}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f8f9fa")}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "white")}
                      >
                        <div className="fs-13 fw-500">{result.display_name}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <Button variant="primary" onClick={handleSearch} disabled={isSearching || !searchQuery.trim()} style={{ backgroundColor: "#3469E7", borderColor: "#3469E7" }}>
                {isSearching ? "Searching..." : "Search"}
              </Button>
            </div>
          </div>

          <div style={{ height: "400px", width: "100%" }}>
            <MapContainer center={mapCenter} zoom={5} style={{ height: "100%", width: "100%" }}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' />
              <LocationPicker setPosition={setMapPosition} />
              <MapUpdater center={mapCenter} />
              {mapPosition && <Marker position={mapPosition} />}
            </MapContainer>
          </div>
          <div className="mt-2 text-muted fs-13">{mapPosition ? `Selected: ${mapPosition.lat.toFixed(6)}, ${mapPosition.lng.toFixed(6)}` : "Click on the map to select a location or search above"}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              setShowMap(false);
              setSearchQuery("");
              setSearchResults([]);
            }}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={handleMapConfirm} disabled={!mapPosition} style={{ backgroundColor: "#3469E7", borderColor: "#3469E7" }}>
            Select Location
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CustomerCreate;
